import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * validates where every element is a valid full day name string (case-insensitive).
 *
 */
export function daysMultiselectValidator(): ValidatorFn {
  const dayPattern = /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)$/i;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // ignore not array and empty
    if (!Array.isArray(value) || value.length === 0) {
      return null;
    }

    // must exist in list
    const invalidDays = value.filter(day =>
      typeof day !== 'string' || !dayPattern.test(day)
    );

    if (invalidDays.length === 0) {
      return null;
    }

    return {
      invalidDayNameInMultiselect: {
        invalidEntries: invalidDays
      }
    };
  };
}
